/**
 * Environment configuration file.
 * Adds more information than .env file.
 * List of available configs:
 */

import { BrandConfiguration, DeployCountry, DeployEnv, EnvConfiguration } from "@types";

/**
 * This class is responsible for checking and managing environment configurations.
 * - Managing brand configurations
 * - Handling country-specific settings
 */
class EnvChecker {
  private static instance: EnvChecker;
  private env: EnvConfiguration;

  private constructor() {
    const currentCountry = import.meta.env.VITE_CURRENT_COUNTRY as DeployCountry;

    // Brand config
    const brandConfig: BrandConfiguration = {
      name: import.meta.env.VITE_BRAND_NAME,
      theme: import.meta.env.VITE_THEME_PRESET,
      key: import.meta.env.VITE_BRAND_KEY,
      group: import.meta.env.VITE_BRAND_GROUP,
      logoMaxHeight: import.meta.env.VITE_BRAND_LOGO_MAX_HEIGHT || "64px",
    };

    this.env = {
      deploymentEnv: import.meta.env.VITE_DEPLOY_ENV as DeployEnv,
      brand: brandConfig,
      accountId: import.meta.env.VITE_ACCOUNT_ID,
      countryCode: currentCountry,
    };
  }

  public static getInstance(): EnvChecker {
    if (!EnvChecker.instance) {
      EnvChecker.instance = new EnvChecker();
    }
    return EnvChecker.instance;
  }

  public getDeployEnv() {
    return this.env;
  }
}

const deployEnvChecker = EnvChecker.getInstance();

export const getDeployEnv = deployEnvChecker.getDeployEnv.bind(deployEnvChecker);

export const isProd = () => {
  return import.meta.env.PROD && import.meta.env.VITE_DEPLOY_ENV === "production";
};

export const envConfig = getDeployEnv();
